<template>
  <div class="submit-pass">
    <div class="pass-img">
      <!-- <van-button v-if="extensionUrl != ''" class="link-btn"
        >{{ seconds }}秒跳转</van-button
      > -->
      <img src="../../assets/images/submit-pass.png" alt="" />
      <p>{{ submitText }}</p>
    </div>
    <div class="code-text">
      <p>关注<b>千锋教育</b>公众号领取福利</p>
      <div class="code-img">
        <img src="../../assets/images/code_border.png" alt="" />
        <img src="../../assets/images/website-ode.png" class="code" alt="" />
      </div>
      <ul class="code-info">
        <li>
          <h3 class="flex-center"><img src="../../assets/images/line.png" alt="" />学习路线</h3>
          <p>
            覆盖前端、Java、Python、云计算、大数据、计算机二级等多个课程视频教程，
            <span> 适合自学</span>
          </p>
        </li>
        <li>
          <h3 class="flex-center"><img src="../../assets/images/play.png" alt="" />名师直播</h3>
          <p>
            学科资深讲师讲解最新技术趋势，保持技术的先进性与前瞻性，
            <span>无缝对接企业需求</span>
          </p>
        </li>
        <li>
          <h3 class="flex-center"><img src="../../assets/images/zip.png" alt="" />资料领取</h3>
          <p>
            技术文档、API文档、jar包，开发工具等
            <span>一站式免费下载</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      seconds: 6,
      // timer: null,
      // extensionUrl: "",
      submitText: "您已提交成功！",
      alreadys: false, // 是否已经提交
    };
  },
  mounted() {
    // this.extensionUrl = this.$route.query.extensionUrl;
    this.alreadys = this.$route.query.already;
    if (this.alreadys) {
      this.submitText = "您已经提交过吆，感谢您的参与~";
    }
    // if (this.extensionUrl && this.extensionUrl !== "") {
    //   this.timer = setInterval(() => {
    //     this.seconds--;
    //     if (this.seconds <= 0) {
    //       clearInterval(this.timer);
    //       // this.seconds = 6;
    //       window.location.href = this.extensionUrl;
    //     }
    //   }, 1000);
    // }
  },
  destroyed() {
    // window.clearInterval(this.timer);
    this.submitText = "您已提交成功！";
  },
};
</script>
<style scoped lang="less">
.submit-pass {
  min-height: 100vh;
  height: 100%;
  padding-bottom: 49px;
  background: linear-gradient(180deg, #bedeff 0%, #75b9ff 100%);
  .pass-img {
    margin: 0px auto;
    text-align: center;
    padding-top: 52px;
    padding-bottom: 40px;
    position: relative;
    img {
      width: 318px;
    }
    p {
      color: #333;
      font-size: 28px;
    }
    .link-btn {
      border-radius: 40px;
      border-color: #999999;
      font-size: 26px;
      padding: 0 34px;
      position: absolute;
      background: transparent;
      top: 30px;
      right: 34px;
      .van-button__text {
        padding-top: 3px;
      }
    }
  }
  .code-text {
    margin: 0 30px;
    background: #ffffff;
    border-radius: 24px;
    padding: 40px 0 40px;
    p {
      font-size: 26px;
      margin-bottom: 26px;
      text-align: center;
      b {
        color: #277fff;
      }
    }
  }
  .code-img {
    margin: 0 auto;
    text-align: center;
    position: relative;
    img {
      width: 406px;
    }
    .code {
      width: 330px;
      height: 330px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -165px;
      margin-left: -165px;
    }
  }
  .code-info {
    background: rgba(39, 127, 255, 0.1);
    border-radius: 16px;
    margin: 43px 47px 0;
    padding: 30px 25px;
    li {
      margin-bottom: 20px;
      img {
        width: 22px;
      }
      h3 {
        font-size: 26px;
        img {
          margin-right: 10px;
        }
      }
      p {
        text-align: left;
        margin-bottom: 0;
        color: #666;
        line-height: 38px;
        span {
          color: #277fff;
        }
      }
    }
    li:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
